import { useItemsStore } from '@/stores/items.js'
import paginationWithStoreMixin from '@/mixins/paginationWithStoreMixin.js'
import fetchItemsMixin from '@/mixins/fetchItemsMixin.js'
export default {
  mixins: [fetchItemsMixin],
  watch: {
    async page () {
      await this.fetchItems()
    }
  }
}
